import { render } from "./ArrowsComp.vue?vue&type=template&id=4b0c3075"
import script from "./ArrowsComp.vue?vue&type=script&lang=js"
export * from "./ArrowsComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__